"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var draft_js_1 = require("draft-js");

var variable_text_editor_utils_1 = require("./variable-text-editor.utils");

var variable_text_editor_styles_1 = require("./variable-text-editor.styles");

var variable_insert_button_component_1 = __importDefault(require("./variable-insert-button.component"));

var variable_decorator_component_1 = __importDefault(require("./variable-decorator.component"));

var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
/*********************
 * DECORATOR
 *********************/


var variableEntityStrategy = function variableEntityStrategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return !!entityKey && contentState.getEntity(entityKey).getType() === variable_text_editor_utils_1.VARIABLE_ENTITY_TYPE;
  }, callback);
};

exports.decorator = new draft_js_1.CompositeDecorator([{
  strategy: variableEntityStrategy,
  component: variable_decorator_component_1.default
}]);
/*****************************
 * Key Biding
 *****************************/

var ENTER_KEY_CODE = 13;
var COMMAND_ENTER = 'command-enter';
/**
 * command + enter => COMMAND_ENTER command を発生させる
 * @param e
 */

var myKeyBindingFn = function myKeyBindingFn(e) {
  if (e.keyCode === ENTER_KEY_CODE && draft_js_1.KeyBindingUtil.hasCommandModifier(e)) {
    return COMMAND_ENTER;
  }

  return draft_js_1.getDefaultKeyBinding(e);
};

var VariableTextEditor = function VariableTextEditor(_ref) {
  var rawText = _ref.rawText,
      variables = _ref.variables,
      onOverlayClick = _ref.onOverlayClick,
      validate = _ref.validate,
      onSave = _ref.onSave;

  var _react_1$useState = react_1.useState(draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(variable_text_editor_utils_1.convertRawTextToRawContentState(variables, rawText)), exports.decorator)),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      editorState = _react_1$useState2[0],
      setEditorState = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(''),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      errorMessage = _react_1$useState4[0],
      setErrorMessage = _react_1$useState4[1];

  var handleSave = function handleSave() {
    setErrorMessage('');
    if (!validate) return onSave(rawText);

    var _validate = validate(editorState.getCurrentContent().getPlainText()),
        error = _validate.error;

    error ? setErrorMessage(error) : onSave(variable_text_editor_utils_1.convertEditorStateToRawText(editorState));
  };

  var handleInsertVariable = function handleInsertVariable(variable) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) return;
    var text = variable.value; // insert text

    var contentWithTextInserted = draft_js_1.Modifier.insertText(editorState.getCurrentContent(), selection, text); // focus inserted text

    var insertedTextSelection = variable_text_editor_utils_1.focusText(selection, selection.getAnchorKey(), selection.getAnchorOffset(), text.length); // create entity

    var contentWithEntityCreated = contentWithTextInserted.createEntity(variable_text_editor_utils_1.VARIABLE_ENTITY_TYPE, 'IMMUTABLE', {
      variable: variable
    }); // apply entity

    var entityKey = contentWithEntityCreated.getLastCreatedEntityKey();
    var contentWithEntityApplied = draft_js_1.Modifier.applyEntity(contentWithEntityCreated, insertedTextSelection, entityKey); // set new EditorState

    var newEditorState = draft_js_1.EditorState.push(editorState, contentWithEntityApplied, 'apply-entity'); // reset selection

    var editorStateWithSelectionReset = draft_js_1.EditorState.forceSelection(newEditorState, contentWithTextInserted.getSelectionAfter());
    setEditorState(editorStateWithSelectionReset);
  };

  return react_1.default.createElement(variable_text_editor_styles_1.StyledWrapperDiv, {
    "data-meta": "variable-text-editor"
  }, react_1.default.createElement(variable_text_editor_styles_1.StyledOverlayDiv, {
    onClick: onOverlayClick
  }), react_1.default.createElement(variable_text_editor_styles_1.StyledEditorWrapperDiv, null, react_1.default.createElement(draft_js_1.Editor, {
    editorState: editorState,
    onChange: setEditorState,
    keyBindingFn: myKeyBindingFn,
    handleKeyCommand: function handleKeyCommand(command) {
      // command + enter で保存処理
      if (command === COMMAND_ENTER) {
        handleSave();
        return 'handled';
      }

      return 'not-handled';
    }
  })), react_1.default.createElement(variable_text_editor_styles_1.StyledButtonBoxDiv, null, react_1.default.createElement(variable_insert_button_component_1.default, {
    variables: variables,
    onVariableClick: handleInsertVariable
  }), react_1.default.createElement(variable_text_editor_styles_1.StyledSaveButton, {
    variant: "outlined",
    color: "primary",
    onClick: handleSave
  }, "\u4FDD\u5B58")), errorMessage && react_1.default.createElement(Alert_1.default, {
    elevation: 6,
    variant: "filled",
    severity: "error",
    style: {
      zIndex: 2
    }
  }, errorMessage) // <StyledErrorMessageP>{errorMessage}</StyledErrorMessageP>
  );
};

exports.default = VariableTextEditor;